var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagIndia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2770_40253",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 38,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7472 20.0005C38.7472 24.974 36.7715 29.7438 33.2547 33.2606C29.7379 36.7773 24.9682 38.753 19.9947 38.753C15.0212 38.753 10.2514 36.7773 6.73467 33.2606C3.21789 29.7438 1.24219 24.974 1.24219 20.0005C1.24219 15.0271 3.21789 10.2573 6.73467 6.74053C10.2514 3.22375 15.0212 1.24805 19.9947 1.24805C24.9682 1.24805 29.7379 3.22375 33.2547 6.74053C36.7715 10.2573 38.7472 15.0271 38.7472 20.0005Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2770_40253)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 38.75L1.25 26.25H38.75V38.75H1.25Z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 26.25L1.25 13.75L38.75 13.75V26.25L1.25 26.25Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 13.75L1.25 1.25L38.75 1.25V13.75L1.25 13.75Z",
    fill: "#FAB446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9941 25.4727C23.0134 25.4727 25.4609 23.0251 25.4609 20.0059C25.4609 16.9866 23.0134 14.5391 19.9941 14.5391C16.9749 14.5391 14.5273 16.9866 14.5273 20.0059C14.5273 23.0251 16.9749 25.4727 19.9941 25.4727Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9944 24.7876C22.6362 24.7876 24.7778 22.646 24.7778 20.0042C24.7778 17.3623 22.6362 15.2207 19.9944 15.2207C17.3526 15.2207 15.2109 17.3623 15.2109 20.0042C15.2109 22.646 17.3526 24.7876 19.9944 24.7876Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9958 20.9603C20.5241 20.9603 20.9524 20.5319 20.9524 20.0036C20.9524 19.4752 20.5241 19.0469 19.9958 19.0469C19.4674 19.0469 19.0391 19.4752 19.0391 20.0036C19.0391 20.5319 19.4674 20.9603 19.9958 20.9603Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7096 20.8649C24.8405 20.8822 24.9607 20.7901 24.978 20.6592C24.9953 20.5282 24.9032 20.408 24.7723 20.3907C24.6413 20.3734 24.5211 20.4655 24.5038 20.5965C24.4865 20.7274 24.5786 20.8476 24.7096 20.8649Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.996 24.7875L20.16 21.9175L19.996 20.5508L19.832 21.9175L19.996 24.7875Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3227 22.055C24.4447 22.1056 24.5847 22.0477 24.6353 21.9257C24.6859 21.8037 24.6281 21.6638 24.5061 21.6132C24.3841 21.5625 24.2441 21.6204 24.1935 21.7424C24.1428 21.8644 24.2007 22.0043 24.3227 22.055Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7564 24.6235L19.6582 21.8935L19.8537 20.5308L19.3413 21.8085L18.7564 24.6235Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6444 23.1051C23.7491 23.1856 23.8993 23.1659 23.9797 23.0611C24.0602 22.9564 24.0405 22.8062 23.9358 22.7258C23.831 22.6453 23.6809 22.665 23.6004 22.7697C23.5199 22.8745 23.5396 23.0246 23.6444 23.1051Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6018 24.1456L19.1788 21.7421L19.7202 20.4765L18.8948 21.5781L17.6018 24.1456Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.715 23.9456C22.7953 24.0505 22.9455 24.0703 23.0503 23.99C23.1551 23.9097 23.175 23.7595 23.0947 23.6547C23.0143 23.5498 22.8642 23.53 22.7594 23.6103C22.6545 23.6906 22.6347 23.8408 22.715 23.9456Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6115 23.3851L18.7574 21.4718L19.6081 20.3894L18.5255 21.2398L16.6115 23.3851Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6025 24.5132C21.653 24.6353 21.7929 24.6933 21.9149 24.6428C22.037 24.5923 22.095 24.4524 22.0445 24.3304C21.9941 24.2083 21.8542 24.1503 21.7321 24.2008C21.6101 24.2513 21.552 24.3911 21.6025 24.5132Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8505 22.3932L18.4179 21.1002L19.5195 20.2748L18.2539 20.8162L15.8505 22.3932Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3771 24.7758C20.3942 24.9068 20.5143 24.9991 20.6453 24.9819C20.7763 24.9648 20.8685 24.8447 20.8514 24.7137C20.8342 24.5827 20.7141 24.4905 20.5832 24.5076C20.4522 24.5248 20.3599 24.6449 20.3771 24.7758Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3674 21.2408L18.1825 20.6568L19.4604 20.1448L18.0977 20.3399L15.3674 21.2408Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1273 24.7135C19.11 24.8444 19.2021 24.9646 19.333 24.9819C19.464 24.9992 19.5842 24.9071 19.6015 24.7762C19.6188 24.6452 19.5267 24.525 19.3957 24.5077C19.2648 24.4904 19.1446 24.5825 19.1273 24.7135Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2087 20.0019L18.0787 20.1659L19.4453 20.0019L18.0787 19.8379L15.2087 20.0019Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9353 24.3305C17.8847 24.4525 17.9425 24.5925 18.0645 24.6431C18.1865 24.6937 18.3264 24.6359 18.3771 24.5139C18.4277 24.3919 18.3699 24.2519 18.2479 24.2013C18.1259 24.1507 17.9859 24.2085 17.9353 24.3305Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.365 18.7643L18.0949 19.666L19.4575 19.8615L18.1798 19.3492L15.365 18.7643Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8968 23.6542C16.8163 23.7589 16.836 23.9091 16.9408 23.9896C17.0455 24.07 17.1957 24.0503 17.2762 23.9456C17.3566 23.8408 17.3369 23.6906 17.2322 23.6102C17.1274 23.5297 16.9772 23.5494 16.8968 23.6542Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8539 17.6135L18.2577 19.1906L19.5235 19.7319L18.4217 18.9065L15.8539 17.6135Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0465 22.7287C15.9416 22.809 15.9218 22.9592 16.0021 23.064C16.0825 23.1689 16.2326 23.1887 16.3375 23.1084C16.4423 23.028 16.4622 22.8779 16.3819 22.773C16.3015 22.6682 16.1514 22.6483 16.0465 22.7287Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6027 16.6231L18.5163 18.7692L19.5988 19.6199L18.7483 18.5372L16.6027 16.6231Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4789 21.6142C15.3569 21.6647 15.2988 21.8046 15.3493 21.9267C15.3998 22.0487 15.5397 22.1068 15.6618 22.0563C15.7839 22.0058 15.8419 21.8659 15.7914 21.7438C15.7409 21.6217 15.601 21.5637 15.4789 21.6142Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5947 15.8619L18.8879 18.4296L19.7134 19.5312L19.172 18.2656L17.5947 15.8619Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2202 20.3907C15.0893 20.4079 14.997 20.528 15.0141 20.659C15.0313 20.7899 15.1514 20.8822 15.2824 20.8651C15.4133 20.8479 15.5056 20.7278 15.4885 20.5968C15.4713 20.4658 15.3512 20.3736 15.2202 20.3907Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7531 15.3827L19.3373 18.198L19.8494 19.476L19.6542 18.1132L18.7531 15.3827Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2826 19.1429C15.1516 19.1255 15.0314 19.2177 15.0141 19.3486C14.9968 19.4796 15.0889 19.5998 15.2199 19.6171C15.3509 19.6344 15.4711 19.5423 15.4884 19.4113C15.5057 19.2803 15.4135 19.1602 15.2826 19.1429Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.992 15.22L19.8281 18.0903L19.9922 19.457L20.1562 18.0902L19.992 15.22Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6616 17.9489C15.5396 17.8983 15.3997 17.9561 15.349 18.0782C15.2984 18.2002 15.3563 18.3401 15.4783 18.3908C15.6003 18.4414 15.7403 18.3835 15.7909 18.2615C15.8415 18.1395 15.7836 17.9995 15.6616 17.9489Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2277 15.3801L20.3261 18.1103L20.1306 19.4732L20.643 18.1953L21.2277 15.3801Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3361 16.9007C16.2313 16.8202 16.0812 16.8399 16.0007 16.9447C15.9202 17.0495 15.9399 17.1996 16.0447 17.2801C16.1494 17.3606 16.2996 17.3409 16.3801 17.2361C16.4605 17.1313 16.4408 16.9812 16.3361 16.9007Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3786 15.8599L20.8016 18.2636L20.2603 19.5293L21.0857 18.4276L22.3786 15.8599Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2694 16.0621C17.189 15.9573 17.0389 15.9374 16.934 16.0178C16.8292 16.0981 16.8093 16.2483 16.8897 16.3531C16.97 16.458 17.1202 16.4778 17.225 16.3975C17.3299 16.3171 17.3497 16.167 17.2694 16.0621Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3729 16.6204L21.2269 18.534L20.3762 19.6164L21.4589 18.766L23.3729 16.6204Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3897 15.4926C18.3393 15.3706 18.1994 15.3125 18.0773 15.363C17.9552 15.4135 17.8972 15.5534 17.9477 15.6754C17.9981 15.7975 18.138 15.8556 18.2601 15.8051C18.3822 15.7546 18.4402 15.6147 18.3897 15.4926Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1423 17.6126L21.5744 18.9056L20.4727 19.731L21.7384 19.1897L24.1423 17.6126Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6113 15.2281C19.5941 15.0971 19.474 15.0048 19.343 15.022C19.2121 15.0391 19.1198 15.1592 19.1369 15.2902C19.1541 15.4212 19.2742 15.5134 19.4051 15.4963C19.5361 15.4792 19.6284 15.3591 19.6113 15.2281Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6175 18.7671L21.802 19.351L20.524 19.863L21.8869 19.668L24.6175 18.7671Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8572 15.2904C20.8745 15.1595 20.7824 15.0393 20.6514 15.022C20.5204 15.0046 20.4002 15.0968 20.3829 15.2277C20.3656 15.3587 20.4577 15.4789 20.5887 15.4962C20.7196 15.5135 20.8399 15.4214 20.8572 15.2904Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7801 20.0023L21.9098 19.8381L20.543 20.002L21.9098 20.1661L24.7801 20.0023Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0452 15.6734C22.0959 15.5514 22.038 15.4115 21.916 15.3608C21.794 15.3102 21.6541 15.368 21.6034 15.49C21.5528 15.612 21.6106 15.752 21.7326 15.8026C21.8546 15.8533 21.9946 15.7954 22.0452 15.6734Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6159 21.24L21.8858 20.338L20.523 20.1423L21.8008 20.6549L24.6159 21.24Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1032 16.3537C23.1837 16.249 23.164 16.0988 23.0592 16.0183C22.9545 15.9378 22.8043 15.9575 22.7238 16.0623C22.6434 16.167 22.663 16.3172 22.7678 16.3977C22.8726 16.4781 23.0227 16.4585 23.1032 16.3537Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.142 22.3946L21.7383 20.8173L20.4726 20.2759L21.5743 21.1014L24.142 22.3946Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9417 17.2811C24.0466 17.2008 24.0665 17.0507 23.9861 16.9458C23.9058 16.8409 23.7557 16.8211 23.6508 16.9014C23.5459 16.9817 23.5261 17.1319 23.6064 17.2367C23.6868 17.3416 23.8369 17.3615 23.9417 17.2811Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3853 23.3869L21.4719 21.2407L20.3895 20.3899L21.2398 21.4726L23.3853 23.3869Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5054 18.3936C24.6275 18.3431 24.6855 18.2033 24.635 18.0812C24.5845 17.9591 24.4447 17.9011 24.3226 17.9516C24.2005 18.002 24.1425 18.1419 24.193 18.264C24.2434 18.3861 24.3833 18.4441 24.5054 18.3936Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3853 24.146L21.0924 21.5783L20.267 20.4766L20.8083 21.7423L22.3853 24.146Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7758 19.6171C24.9068 19.6 24.9991 19.4799 24.9819 19.3489C24.9648 19.2179 24.8447 19.1256 24.7137 19.1428C24.5827 19.1599 24.4905 19.28 24.5076 19.411C24.5248 19.542 24.6448 19.6343 24.7758 19.6171Z",
    fill: "#41479B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2348 24.6251L20.6509 21.8098L20.1389 20.5318L20.334 21.8946L21.2348 24.6251Z",
    fill: "#41479B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIndia);
export default __webpack_public_path__ + "static/media/flag-india.44d12dbb7d75cd29acf063785abac5d2.svg";
export { ForwardRef as ReactComponent };